import styled, { css } from 'styled-components';

export const ListItems = styled.ul`
  ${({ theme }) => css`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    flex-wrap: wrap;
    list-style: none;
    padding: 0;
    margin: 0;
    width: 100%;
    gap: 16px;
 
    @media (max-width: ${theme.v2.breakpoints.md}) {
      grid-template-columns: repeat(1, 1fr);
    }    

    @media (min-width: ${theme.v2.breakpoints.lg}) {
      grid-template-columns: repeat(2, 1fr);
    }    

    @media (min-width: ${theme.v2.breakpoints.xl}) {
      grid-template-columns: repeat(2, 1fr);
    }    
  `};
`;

export const Item = styled.li`
  ${({ theme, $isDisabledButton }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px;
    border: 1px solid ${theme.v2.colors.neutral.highMedium};
    border-radius: 16px;
    gap: 8px;
    cursor: ${$isDisabledButton ? 'default' : 'pointer'};
    transition: .3s;
    opacity: ${$isDisabledButton ? 0.5 : 1};

    &:hover {
      border-color: ${!$isDisabledButton && theme.v2.colors.brand.primaryMedium};
      box-shadow: ${!$isDisabledButton && `0 0 20px 0 ${theme.v2.colors.brand.primaryMedium}33`};
    }

    &:hover {
      border-color: ${theme.v2.colors.brand.primaryMedium};
      box-shadow: 0 0 20px 0 ${theme.v2.colors.brand.primaryMedium}33;
    }

    &:active {
      background-color: ${theme.v2.colors.brand.primaryLowLight};
      border-color: transparent;
      box-shadow: none;
    }
  `}
`;

export const ItemIcon = styled.img`
  width: 24px;
  height: 24px;
  display: block;
  margin: 0;
`;

export const ItemContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex-grow: 1;
`;

export const ItemName = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    color: ${theme.v2.colors.neutral.lowDark};
  `}
`;

export const ItemArrow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
